import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {centerIslandThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PLACEMENTS} from "../constants";

import Cabinet from "../subparts/centerIsland/cabinet";
import Countertop from "../subparts/centerIsland/countertop";
import Chairs from "../subparts/centerIsland/chairs";
import Faucet from "../subparts/centerIsland/faucet";
import Sink from "../subparts/centerIsland/sink";
import Handle from "../subparts/centerIsland/handle";
import CenterIslandShadow from "../subparts/centerIsland/centerIslandshadow";
import Stovetop from "../subparts/centerIsland/stovetop";
import Range from "../subparts/centerIsland/range";
import Edge from "../subparts/centerIsland/edge";
import ChairsShadow from "../subparts/centerIsland/chairsShadow";

export default class CenterIsland extends Part {
  static id = 'CenterIsland';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'CenterIsland';
    this.partThumbnail = centerIslandThumbnail;
    this.translateId = "visualizer.kitchen.center_island";

    // related items
    this.cabinet = null;
    this.countertop = null;
    this.chairs = null;
    this.edge = null;
    this.faucet = null;
    this.sink = null;
    this.range = null;
    this.centerIslandshadow = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      shouldLoadInDifferentGroups = false,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Center Island":
        relatedItemName = "cabinet";
        RelatedItemClass = Cabinet;
        break;
      case "Center Island Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = Countertop;
        break;
      case "Center Island Handle":
        relatedItemName = "handle";
        RelatedItemClass = Handle;
        break;
      case "Chair Shadow":
        relatedItemName = "chairsShadow";
        RelatedItemClass = ChairsShadow;
        break;
      case "Chair":
        relatedItemName = "chairs";
        RelatedItemClass = Chairs;
        break;
      case "Center Island Shadow":
        relatedItemName = "centerIslandshadow";
        RelatedItemClass = CenterIslandShadow;
        break;
      case "Faucet":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "faucet";
          RelatedItemClass = Faucet;
        }
        break;
      case "Sink":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "sink";
          RelatedItemClass = Sink;
        }
        break;
      case "Stovetop":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "stovetop";
          RelatedItemClass = Stovetop;
        }
        break;
      case "Range":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "range";
          RelatedItemClass = Range;
        }
        break;
      case "Edge Profile":
        shouldLoadInDifferentGroups = true;
        relatedItemName = "edge";
        RelatedItemClass = Edge;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return !shouldLoadInDifferentGroups;
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Center Island', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => {
        if (item.partId === "center_island_handle") {
          item.visible = item.features.filter(f => f.matchesMetaForArrayOfConditions(item.getArrayOfConditions())).length;
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  getCabinetType() {
    return this.cabinet && this.cabinet.activeFeature
      ? this.cabinet.activeFeature.dbFeature.metaData["Cabinet"]
      : ""
  }

  getChairType() {
    return this.chairs && this.chairs.activeFeature
      ? this.chairs.activeFeature.dbFeature.metaData["Chair"]
      : ""
  }

}
